module.exports = __webpack_public_path__ + "img/ic-dropdown-hatchery.73a3445e.svg";